import React, { createContext, useContext, useEffect, useState } from "react";
import appStore from "./mobxStore/AppStore";
import { api } from "api/API";
import Loading from "./components/Loading";
import { Box } from "@mui/material";
import { observer } from "mobx-react";

const EntityContext = createContext(null);

export const EntityProvider = observer(({ children }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchEntities = async () => {
      const storedEntityId = localStorage.getItem("selectedEntity");
      const userId = appStore.loginResponse.user[0].userId;

      try {
        const res = await api.get(`get-user-entities/${userId}`);
        const userEntities = res?.success && Array.isArray(res.data)
          ? res.data
          : [];

        appStore.setUserEntities(userEntities);

        if (userEntities.length === 0) {
          appStore.setSelectedEntity(-1);
          localStorage.removeItem("selectedEntity");
          return;
        }

        const storedEntity = storedEntityId ? Number(storedEntityId) : -1;
        const storedEntityIsAllowed = userEntities.some(
          (entity) => entity.entityId === storedEntity
        );

        if (storedEntityIsAllowed) {
          appStore.setSelectedEntity(storedEntity);
        } else if (appStore.selectedEntity === -1) {
          appStore.setSelectedEntity(userEntities[0]?.entityId ?? -1);
        }

        localStorage.removeItem("selectedEntity");
      } catch (err) {
        console.error("API Error:", err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchEntities();
  }, []);

  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.setItem("selectedEntity", String(appStore.selectedEntity));
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [appStore.selectedEntity]);

  const updateEntity = (newEntity) => {
    appStore.setSelectedEntity(newEntity);
  };

  if (isLoading) {
    return (
      <Box style={{ height: "96%" }}>
        <Loading />
      </Box>
    );
  }

  return (
    <EntityContext.Provider
      value={{
        entity: appStore.selectedEntity,
        entities: appStore.userEntities,
        updateEntity,
      }}
    >
      {children}
    </EntityContext.Provider>
  );
});

export const useEntity = () => {
  const context = useContext(EntityContext);
  if (!context) {
    throw new Error("useEntity must be used within an EntityProvider");
  }
  return context;
};
